import { PERSONAL_PAGE_SUBTYPE_LABELS } from '../../labels';
import { cap } from '../capability-builder';
import { donationUnitInventory, donationUnitLabels, donationUnitPayments } from '../item-presets';
import type { PersonalPageCapabilities } from '../types';

const donationIntroText =
  'אם אתם רוצים שהתורמים יוכלו לבחור סכום תרומה מומלץ, או שהם יצטרכו לבחור יחידות תרומה בסכומים נקובים – תוכלו לעשות זאת כאן. אם מספיק לכם שהתורמים יבחרו בעצמם באופן חופשי כל סכום שהוא, המשיכו ישירות לשלב הבא.';

export const campaignCapabilities: Record<string, PersonalPageCapabilities> = {
  openDonation: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.openDonation.singular,
    hasStartEndRange: false,
    supportsGroups: false,
    itemKind: 'donationUnit',
    itemOptions: donationUnitPayments,
    allowFreeRecurringDonation: true,
    dataDestination: 'campaigns',
    itemLabels: donationUnitLabels,
    defineStepLabelConfig: {
      formSubject: 'תרומה',
      overrides: { introText: donationIntroText }
    }
  }),

  partnershipCampaign: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.partnershipCampaign.singular,
    hasGoal: true,
    supportsGroups: true,
    itemKind: 'donationUnit',
    itemOptions: donationUnitPayments,
    allowFreeRecurringDonation: true,
    dataDestination: 'campaigns',
    itemLabels: donationUnitLabels,
    defineStepLabelConfig: {
      formSubject: 'תרומה',
      overrides: { introText: donationIntroText }
    },
    defineStepChoice: {
      label: 'קמפיין שותפות',
      helpText:
        'אפשרו לתורמים לבחור סכום תרומה מומלץ מרשימה, או להחליט בעצמם על סכום התרומה. תוכלו גם לקבוע יעד גיוס שיוצג בדף הקמפיין. מתאים להתרמה שנתית ולקמפיין גיוס המונים.',
      icon: 'volunteer'
    }
  }),

  focusedDonation: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.focusedDonation.singular,
    supportsGroups: true,
    requiresDefinedItems: true,
    soldRemainingDisplay: true,
    itemKind: 'donationUnit',
    itemOptions: donationUnitInventory,
    dataDestination: 'campaigns',
    itemLabels: donationUnitLabels,
    defineStepLabelConfig: {
      formSubject: 'תרומה',
      overrides: {
        registrationLimitTitle: 'מכסה כוללת לקמפיין',
        registrationLimitSubtitle: 'הגבלת סך התרומות בדף (בנוסף למלאי לכל יחידת תרומה)'
      }
    },
    defineStepChoice: {
      label: 'התרמה ממוקדת',
      helpText:
        'הגדירו סכומי תרומה נקובים עם כמות מוגבלת, והתורמים יבחרו יחידת תרומה או סל יחידות לתרומה. מתאים להתרמות למטרות מוגדרות.',
      icon: 'confirmation'
    }
  }),

  annualCampaign: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.annualCampaign.singular,
    hasGoal: true,
    supportsGroups: true,
    hasGoalProgress: true,
    hasRecentDonations: true,
    hasAllDonations: true,
    itemKind: 'donationUnit',
    itemOptions: donationUnitPayments,
    allowFreeRecurringDonation: true,
    dataDestination: 'campaigns',
    itemLabels: donationUnitLabels,
    defineStepLabelConfig: {
      formSubject: 'תרומה',
      overrides: { introText: donationIntroText }
    }
  }),

  choiceDonation: cap({
    label: PERSONAL_PAGE_SUBTYPE_LABELS.choiceDonation.singular,
    allowSubtypeChoice: true,
    subtypeChoiceOptions: ['partnershipCampaign', 'focusedDonation'],
    dataDestination: 'campaigns',
    itemLabels: donationUnitLabels,
    defineStepLabelConfig: {
      formSubject: 'תרומה',
      overrides: {
        choiceSectionTitle: 'בחר סוג התרומה',
        introText: donationIntroText,
        accordion: {
          unitsCardTitle: 'בחירת סוג התרומה',
          unitsCardDescription: 'בחרו בין קמפיין שותפות להתרמה ממוקדת.'
        }
      }
    }
  })
};
